module.exports = __webpack_public_path__ + "img/escola_creative_learning_pediatria.7739ee1d.jpeg";